import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { gbifKeyFromMatch, gbifMatchUrl, gbifSpeciesUrl } from './gbif.js'

/** Opened in a new tab from a taxon link: matches the name against the GBIF backbone and moves on to its page. */
export function GbifRedirectPage() {
  const species = useParams().species ?? ''
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!species) return
    let live = true
    fetch(gbifMatchUrl(species))
      .then((r) => (r.ok ? r.json() : null))
      .then((m) => (m ? gbifKeyFromMatch(m) : null))
      .catch(() => null)
      .then((key) => {
        if (!live) return
        if (key === null) setFailed(true)
        else window.location.replace(gbifSpeciesUrl(key))
      })
    return () => {
      live = false
    }
  }, [species])

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      {!species || failed ? (
        <p>GBIF has no taxon matching “{species}”.</p>
      ) : (
        <>
          <span className="loading loading-spinner loading-md" />
          <p>Looking up “{species}” on GBIF…</p>
        </>
      )}
    </main>
  )
}
